import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import useStyles from './TooltipStyle';
import UtilsService from '../../../services/UtilsService';

const CustomTooltip = ({ className = '', showTooltip = true, ...restProps }) => {
    const classes = useStyles();
    const rootClasses = UtilsService.getClassName([
        classes.tooltip,
        className,
    ]);

    return showTooltip
        ? <Tooltip {...restProps} classes={{ tooltip: rootClasses }}/>
        : <>{restProps.children}</>;
};

CustomTooltip.propTypes = {
    className: PropTypes.string,
};

CustomTooltip.defaultProps = {
    className: '',
};

export default CustomTooltip;
